import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { colors } from './theme/colors';
import { GenericErrorPage } from './pages/GenericErrorPage';
import { lazy } from 'react';

const SelectOrganisationAndMarketPage = lazy(
  () => import('./pages/SelectMarket/SelectMarketPage')
);

const SpendingLimitPage = lazy(
  () => import('./pages/SpendingLimit/SpendingLimitPage')
);

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: '#E8E8E85',
      },
    },
  },
  colors: {
    colors,
  },
});

function App() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  if (!isAuthenticated && !isLoading) {
    loginWithRedirect();
  }

  return (
    <ChakraProvider theme={theme}>
      <RouterProvider
        router={createBrowserRouter(
          createRoutesFromElements(
            <Route errorElement={<GenericErrorPage />}>
              <Route path="/" element={<SelectOrganisationAndMarketPage />} />
              <Route path="/spending-limit" element={<SpendingLimitPage />} />
            </Route>
          )
        )}
      />
    </ChakraProvider>
  );
}

export default App;
